import { TS_AddonWellness }     from '../TravelSeller/Models/TS_AddonWellness';
import { BookingItemInterface } from './BookingItemInterface';

export class AddonWellness extends TS_AddonWellness implements BookingItemInterface {
}